window.multiaddtocart = window.multiaddtocart || {};

multiaddtocart.multiAddToCart = (function($){
  function init() {
    
    loadCartPopup(),closePopups(),loadMore(),multiCartClick(),singleCartClick(),listQty(),incDecQty(),showHideOption(),current_item_list;
  }
	
  function loadCartPopup() {
    jQuery(document).on('click','.cart_anchor',function(e){
    	e.preventDefault();
   		showCartList();
    });
  }
	
  function closePopups() {
  	jQuery(document).on("click",'.cart_close,.continue_btn',function() {
  	jQuery('.multiaddtocartlist').css('display','none');
  	});
  
  	jQuery(document).bind("click touchend",function(e) {
		var multcartjQtarget = e.target; 

   		if(jQuery('.desc_modal').is(multcartjQtarget)) {    
     	jQuery('.desc_modal').css('display','none');
		}
    
    	if(jQuery('.multiaddtocartlist').is(multcartjQtarget)) {    
     	jQuery('.multiaddtocartlist').css('display','none');
		}
  	});
  }
  
  function loadMore() {
    if(jQuery(".multcart_more a").length > 0) {
  		jQuery(".multcart_more a").click(function(event) {
   	 		if(!jQuery(this).hasClass("disabled")) {
			var triggered = false;    
        	loadMoreOnClick();        
    		}
       	 	event.preventDefault();
    	});
    }
  }
  
  function loadMoreOnClick() {
    var load_more_url = jQuery('.multcart_more a').last().attr("href");
    
    jQuery(".multicart-loader").css("display","block");

    jQuery.ajax({
        type: "GET",
        url: load_more_url,
        success: function(data) {
          	jQuery(".multicart-loader").css("display","none");
       
          	if(jQuery(data).find(".multcart_more a").length > 0) {
            	jQuery(".multcart_more").replaceWith(jQuery(data).find(".multcart_more"));
              	if(jQuery(".multcart_more a").attr('href')) {
              		loadMore();
            	}
          	} else {
            	if(jQuery(".multcart_more a").length > 0) {
            	jQuery(".multcart_more a").remove();
            	}
           }
          
           if(jQuery(data).find("#list-view-items").length > 0) {
              if(jQuery("#multi-addToCart").length){
                 jQuery(data).find('#multi-addToCart > tbody').each(function() {
                 jQuery('#multi-addToCart > tbody').append(jQuery(this).children("tr"));
                 });
              }
           }
        },
        error:function(XMLHttpRequest,textStatus) {
          	alert("There is some problem, please try again later!");
        },
        dataType: "html"
    });
  }
 
  function pushitems(el,product_id) {
      var currentQty = parseInt(jQuery(el).val()) || 0;
      current_item_list.items = jQuery.grep(current_item_list.items, function(e){ 
    	if(e.product_id == product_id) {
       		return false;
     	} else {
       		return true;
        }
      });      	
      current_item_list.items.push({'product_id': product_id,'qty': currentQty});
  }
  
  function multiCartClick() { 
    jQuery(document).on('click','.current_list-add-to-cart',function(e){
        e.preventDefault();
     	
      	//Add to cart with preset qty. function starts here - 786/92/ASK
   		jQuery(".multcart-container .list-product-qty").each(function() {
       		var ele_id = jQuery(this).attr("id");
        	var variant_id = ele_id.replace("updates_", "");
    		var qtyInput = jQuery("#"+ele_id);
        	var currentVal = parseInt(qtyInput.val()) || 0;
         
        	if(currentVal>0) {
        	pushitems(qtyInput,variant_id);
       		}
  	  	});
      
       if(current_item_list.items.length == 0) {
         alert(window.no_items_added_text);
       } else { 
       	jQuery(this).attr("disabled",true);
        jQuery(".multicart-loader").show();
      
       	current_item_list.addItems();
       }
      
      //Ended here - 786/92
    });
  }
  
  function singleCartClick() {
    jQuery(document).on('click','.singleCart',function(i){
      
      i.preventDefault();
      
      var att = jQuery(this).attr("id"),
      qty= jQuery(".currqty_"+att).val(); 
             	  
      if(qty == 0 || !jQuery.isNumeric(qty)) { 
      	alert(window.no_items_added_text); 
        jQuery(".currqty_"+att).val(0);      
      } 
      else {
      	addinToCart(att,qty); 
      }
    });
  }
  
  function getTotalCount() {
    jQuery.getJSON('/cart.js').done(function(cart) {
      
    	if(cart.item_count > 1) { 
   			jQuery('#collection-multicart #multicartDiv').html(cart.item_count+' '+window.items_txt); 
         }
         else {
         	jQuery('#collection-multicart #multicartDiv').html(cart.item_count+' '+window.item_txt); 
         }
    });
  }
  
  function flyToElement(flyer,flyingTo) {
    var multcartjQfunc = jQuery(this);
    var divider = 2;
    var flyerClone = jQuery(flyer).clone();
    jQuery(flyerClone).css({ position: 'absolute', top: jQuery(flyer).offset().top + "px", left: jQuery(flyer).offset().left + "px", opacity: 1, 'z-index': 1000 });
    jQuery('body').append(jQuery(flyerClone));
    var gotoX = jQuery(flyingTo).offset().left + (jQuery(flyingTo).width() / 2) - (jQuery(flyer).width() / divider) / 2;
    var gotoY = jQuery(flyingTo).offset().top + (jQuery(flyingTo).height() / 2) - (jQuery(flyer).height() / divider) /2;
   
   if(jQuery('#admin_bar_iframe').width() > 100) {
      gotoY = parseFloat(gotoY)-45;
    } else {
      gotoY = parseFloat(gotoY);
    } gotoX = parseFloat(gotoX)-15;
    
    jQuery(flyerClone).animate({
            opacity: 0.4,
            left: gotoX,
            top: gotoY,
            width: jQuery(flyer).width()/3,
            height: jQuery(flyer).height()/3
        }, 700,
        function() {
            jQuery(flyingTo).fadeOut('fast', function() {
                jQuery(flyingTo).fadeIn('fast', function() {
                    jQuery(flyerClone).fadeOut('fast', function() {
                        jQuery(flyerClone).remove();
                    });
                });
            });
        });
	} 
  
  function addinToCart(att,qty) {
    qty = parseInt(qty);
    var post_data = { id: att, quantity: qty }
    jQuery(".multicart-container .qty-form").find("#"+att).val(window.adding_text);
    jQuery(".multicart-container .qty-form").find("#"+att+" span").html(window.adding_text); 
		
    jQuery.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: post_data,
        success: function(itemData) {
            	getTotalCount();

				var cart = jQuery('#multicartDiv');
           		var imgtodrag = jQuery(".multicart-container .qty-form .singleCart").closest('tr[id$="'+att+'"]').find(".product-img img:eq(0)");
        
                if(window.show_prd_image == "yes") {
           		flyToElement(jQuery(imgtodrag), jQuery('#multicartDiv'));
                }
          
            	window.setTimeout(function() { 
              		jQuery(".multicart-container .qty-form").find("#"+att).val(window.thank_you_text);
    				jQuery(".multicart-container .qty-form").find("#"+att+" span").html(window.thank_you_text); 
            	}, 400);
          
           	 	window.setTimeout(function() { 
              		jQuery(".multicart-container .qty-form").find("#"+att).val(window.add_more_text);
    				jQuery(".multicart-container .qty-form").find("#"+att+" span").html(window.add_more_text);  
            	}, 1000);
        },
        error: function(XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');

            response = response.description;  
            response = response.replace("You can't add more",too_many_items_in_cart[0]);
            response = response.replace("to the cart.",too_many_items_in_cart[1]);
            response = response.replace("All",all_items_in_cart[0]);
            response = response.replace("are in your cart.",all_items_in_cart[1]);
            response = response.replace("You can only add",only_n_items_available[0]);
            
            jQuery(".multicart-container .qty-form").find("#"+att).val(window.single_atc_text);
    		jQuery(".multicart-container .qty-form").find("#"+att+" span").html(window.single_atc_text);  
            
            alert(response);
        }
    });		 
  }
  
  var current_item_list = {
    items: [],
    errors:[],
    addItems: function() {
      
      if(this.items.length > 0) {
   
      if(typeof this.items != undefined) {
        
        Shopify.queue = [];
        
        jQuery.each(this.items, function(k,arr){
	    	Shopify.queue.push({
	      		variantId: arr['product_id'],
          		quantity: arr['qty']
	    	});
        });
        
         Shopify.moveAlong = function() {
	  	
     	 var err_desc = "";
         
         //If we still have requests in the queue, let's process the next one.
	 	 if(Shopify.queue.length) {
	    	var request = Shopify.queue.shift();
	    	var data = 'id='+ request.variantId + '&quantity='+request.quantity;
	    	jQuery.ajax({
	      		type: 'POST',
              	url: '/cart/add.js',
	      		dataType: 'json',
	      		data: data,
	      		success: function(res){
	        		Shopify.moveAlong();
	     		},
             	error: function(XMLHttpRequest,textStatus) {
                   		var response = eval('(' + XMLHttpRequest.responseText + ')');
            			response = response.description;
                		response = response.replace("You can't add more",too_many_items_in_cart[0]);
            			response = response.replace("to the cart.",too_many_items_in_cart[1]);
            			response = response.replace("All",all_items_in_cart[0]);
            			response = response.replace("are in your cart.",all_items_in_cart[1]);
            			response = response.replace("You can only add",only_n_items_available[0]);
                  		current_item_list.errors.push({'err_res':response});
                   
	     				//if it's not last one Move Along else update the cart number with the current quantity
		  				if (Shopify.queue.length){
		    				Shopify.moveAlong();
		  				} else {
		    				getTotalCount();
                          	showCartList();
                            reset_current_list();
		  				}
	      		}
           });
      	} else{
          
          	getTotalCount(); 
          	showCartList();
         	reset_current_list();
      	} 
    	};
    	Shopify.moveAlong();
      } 
    } else {
    alert(window.no_items_added_text);
  	}
    },
  }
  
  function isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if(charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
    }
    return true;
  }
  
  function listQty() {
    jQuery(document).on('keypress','.list-product-qty',function(evt) {
       var isno = isNumber(evt);
       if(!isno) {
         return false;
       }
    });
   
    jQuery(document).on('keyup','.list-product-qty',function() {
         	var ele_id = jQuery(this).attr("id");
          	var product_id = ele_id.replace("updates_", "");
    		var multcartjQqtyInput = jQuery("#"+ele_id);
            var currentVal = parseInt(multcartjQqtyInput.val()) || 0;
  		    var qtyMax = parseInt(multcartjQqtyInput.attr('max'));
            
  			if(currentVal > qtyMax) {
          		alert(window.stock_max_alert1+qtyMax+window.stock_max_alert2);
   		 		multcartjQqtyInput.val(qtyMax);	
  			} 
         
         	if(currentVal >= 1) {
  				pushitems(multcartjQqtyInput,product_id);
            } else {
            	current_list_remove(product_id);
         	}
	 });
  }
  
  function incDecQty() {
      //Increment qty function 
      jQuery(document).on('click','.qtyplus',function() {       
          	var ele_id = jQuery(this).siblings(".list-product-qty").attr("id");
          	var product_id = ele_id.replace("updates_", "");
    		var multcartjQqtyInput = jQuery("#"+ele_id);
  			var currentVal = parseInt(multcartjQqtyInput.val());
  			var qtyMax = parseInt(multcartjQqtyInput.attr('max'));
          	
          	if(currentVal >= qtyMax) {
              	alert(window.stock_max_alert1+qtyMax+window.stock_max_alert2);
   		 		multcartjQqtyInput.val(qtyMax);
              
  			} else {
  				multcartjQqtyInput.val(currentVal+1);	
          	}
          
          	pushitems(multcartjQqtyInput,product_id);
		});
  
  		//Decrement qty function
		jQuery(document).on('click','.qtyminus',function() {    
          
          	var ele_id = jQuery(this).siblings(".list-product-qty").attr("id");
          	var product_id = ele_id.replace("updates_", "");
    		var multcartjQqtyInput = jQuery("#"+ele_id);
  			var currentVal = parseInt(multcartjQqtyInput.val());
          
    		if(currentVal >= 1) {
      			multcartjQqtyInput.val(currentVal - 1);
           		pushitems(multcartjQqtyInput,product_id);
   		 	} else {
              	current_list_remove(product_id);
            }
	    });
   }
  
  function showHideOption(){
     	//Show / hide variant options
  		jQuery(document).on('click','.showhidevariant',function() { 
          
           	var varintof_productid = jQuery(this).data("variantproid");
           	jQuery("."+varintof_productid).toggle();
           		jQuery(this).val(function(i,val){
            	return val ===  window.show_options ? window.hide_options : window.show_options;
      		});
        });
  }
  
  function current_list_remove(remove_prdid) {
    	current_item_list.items = jQuery.grep(current_item_list.items, function(e){ 
  
    		if(e.product_id == remove_prdid) {
       			return false;
     		} else {
       			return true;
    		}
   		});   
     	
     	return true;
   }
  
   function showCartList() {
     jQuery(".multicart-loader").show();
     
     jQuery.getJSON('/cart.js').done(function(cart) {
       	jQuery(".multicart-loader").hide();
    	jQuery(".multiaddtocartlist").css('display','block');
        jQuery(".modal-header").find("#total_cnt").html(window.cart_popup_title1+" "+cart.item_count+" "+window.cart_popup_title2);
       	
       	var cart_row = "";
       	jQuery('#multicart-minilist').empty();
       	jQuery(".multiaddtocartlist .modal-body").show();
        jQuery(".multiaddtocartlist .modal-footer").show();
       
        if(cart.item_count > 0) {
       	
          	jQuery.each(cart.items, function(item_index,item_arr) {
          	cart_row = jQuery('<tr class="multi-cartitem" id="prditem-'+item_arr.id+'">');
              
            if(window.show_prd_image == "yes") {
            
            var pro_img = "";
            
            if(item_arr.image != null) {
              	pro_img = item_arr.image;
                var img_without_extension = pro_img.substr(0, pro_img.lastIndexOf('.')) || pro_img;
             	var img_ext = pro_img.split('.').pop();
             	img_ext = img_ext.substring(0, img_ext.indexOf('?v'));
				pro_img = img_without_extension+"_90X90."+img_ext;    		
           } else {
           		pro_img = window.multicart_no_image;
           }
              
           cart_row.append(jQuery('<td class="cws_prd_img">').html('<a href="'+item_arr.url+'"><img src="'+pro_img+'"/></a>'));   
           
           }
              
           	cart_row.append(jQuery('<td class="cws_prd_name">').html('<a href="'+item_arr.url+'">'+item_arr.title+'</a>'));
            cart_row.append(jQuery('<td class="cws_prd_qty">').html('<p>'+item_arr.quantity+'</p>'));
          	cart_row.append(jQuery('<td class="cws_price">').html('<span>'+Shopify.formatMoney(item_arr.price, window.multicart_money_format)+'</span>'));
 			
          	jQuery('#multicart-minilist').append(cart_row);
            });
      
        	jQuery(".modal-footer").find(".sub_total_amount").html('<span>'+Shopify.formatMoney(cart.total_price, window.multicart_money_format)+'</span>');
       
        } else {
          jQuery(".multiaddtocartlist .modal-body").hide();
          jQuery(".multiaddtocartlist .modal-footer").hide();
        }
     });
   }
  
   function reset_current_list() {
     var items_count = current_item_list.items.length;
     current_item_list.items = [];
     jQuery("p").remove(".err_text");
     jQuery('.multicart-container .list-product-qty').val(window.preset_qty_val).trigger("change");	
     jQuery(".multicart-container .qty-form .singleCart").val(window.single_atc_text);
     jQuery(".current_list-add-to-cart").attr("disabled",false);
     jQuery(".multicart-loader").hide();
     
    if(current_item_list.errors.length > 0) {
      	jQuery(".multicart_err").css("display","block");
   		jQuery(".multicart_err").append("<p class='err_text'>"+window.add_to_cart_error_message+"</p>");
     	    
      	var temp_err = current_item_list.errors;
       	current_item_list.errors = [];
      	var err_cnt = 0;
       	
      	jQuery.each(temp_err,function(key,value) {
        	err_cnt = key+1;	 	
            jQuery(".multicart_err").append("<p class='err_text' id='err_text_'"+key+"'>"+value.err_res+"</p>");
		});   
      
        setTimeout(function() { jQuery('html,body').animate({scrollTop: jQuery(".multicart_err").offset().top });}, 2000);      
    } else {
      jQuery(".multicart_err").css("display","none");
    }
   }
  
   return {
   	init: init,
   	reset_current_list:reset_current_list,
    current_item_list:current_item_list,
   }
   
}(jQuery)); 
           
jQuery(document).ready(function() {
    //Very Important for Modal css conflict with theme CSS.
  	jQuery(".page-container").removeClass("page-container"); 
  
    //Display left sidebar. - 786/ASK
    if (jQuery(window).width() >= 999) {
		jQuery(".multicart-container .sidebar .block .block-content").show();
	} else {
		jQuery(".multicart-container .sidebar .block .block-content").hide();
	}
  
  	//Display View more/less. - 786/ASK
    jQuery('.multicart-container ul.sidebar-collections').each(function(){
   		var jQueryul = jQuery(this),
        jQuerylis = jQueryul.find('li:gt("'+window.cat_limit+'")'),
        isExpanded = jQueryul.hasClass('expanded');
    	jQuerylis[isExpanded ? 'show' : 'hide']();
    
  		if(jQuerylis.length > 0) {
      	jQueryul.append(jQuery('<li class="expand"><span>' + (isExpanded ? window.view_less_category_text : window.view_more_category_text) + '</span></li>').click(function(event){
      	var isExpanded = jQueryul.hasClass('expanded');
        	event.preventDefault();
        	jQuery(this).text(isExpanded ? window.view_more_category_text : window.view_less_category_text);
        	jQueryul.toggleClass('expanded');
        	jQuerylis.toggle();
      	}));
    	}
   	});   
  
    //Categories for Mobile View
	jQuery('.multicart-container .sidebar .sub-title').on("click",function() {
		if (jQuery(window).width() <= 999) {
		jQuery('.sidebar .block .block-content').slideToggle();
		}
		jQuery('block-content').toggleClass('toggled-on');
        jQuery('.multicart-container .sidebar .sub-title').toggleClass('active');
	});
  
    if(window.coll_prd_count > 0) {
  	var current_sortby = getUrlParameter('sort_by');
  
  	if(typeof current_sortby !== "undefined") {
    	jQuery('#multicart_sort_by').val(current_sortby);
    	jQuery("#multicart_sort_by option[value='"+current_sortby+"']").attr('selected','selected');
  	} else {
     	jQuery("#multicart_sort_by option[value='"+window.coll_default_sort_by+"']").attr('selected','selected');
  	}
  
  	Shopify.queryParams = {};
	if(location.search.length) {
  		for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    		aKeyValue = aCouples[i].split('=');
          	if (aKeyValue.length > 1) {
      			Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    		}
  		}
	}
  
	jQuery('#multicart_sort_by').on('change', function() {
    	Shopify.queryParams.sort_by = jQuery(this).val();	
    	location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  	});
    }
  	multiaddtocart.multiAddToCart.init(); 
});